<div class="card">
	<div class="card-header bg-transparent border-0 d-flex justify-content-between align-items-center pt-3 pt-md-4 px-3 px-md-4 pb-0">
		<h5 class="mb-0 fw-semibold">Organization Admins</h5>
		<a [routerLink]="settingsLink" [queryParams]="{ tab: 'settings', subtab: 'manage-organization-admins' }" class="btn btn-primary">
			<fa-duotone-icon icon="user-shield" class="me-1" secondaryOpacity="0.5" />
			Manage Admins
		</a>
	</div>

	<div class="card-body px-3 px-md-4 pt-2 pt-md-3 pb-3 pb-md-4">
		@if (isLoading()) {
			<div class="placeholder-glow">
				@for (i of [1, 2, 3]; track i) {
					<div class="d-flex align-items-center gap-3 py-2 border-bottom">
						<span class="placeholder rounded-circle" style="width: 50px; height: 50px; min-width: 50px;"></span>
						<div class="flex-grow-1">
							<span class="placeholder col-4 placeholder-sm d-block mb-1"></span>
							<span class="placeholder col-3 placeholder-xs"></span>
						</div>
					</div>
				}
			</div>
		} @else if (hasError()) {
			<div class="text-danger text-center py-4">
				<fa-duotone-icon icon="circle-exclamation" size="2x" class="mb-2 d-block" secondaryOpacity="0.3" />
				<span class="small">Unable to load organization admins.</span>
			</div>
		} @else if (admins().length === 0) {
			<div class="text-muted text-center py-4">
				<fa-duotone-icon icon="user-shield" size="2x" class="mb-2 d-block" secondaryOpacity="0.3" />
				<span class="small">No organization admins assigned.</span>
			</div>
		} @else {
			<div class="list-group list-group-flush">
				@for (admin of admins(); track admin.memberId) {
					<div class="list-group-item d-flex justify-content-between align-items-center border-start-0 border-end-0 px-0 py-2">
						<div class="d-flex align-items-center gap-3 min-w-0">
							<ms-avatar
								[identity]="admin"
								[avatarSize]="avatarSize"
								[avatarShape]="avatarShape"
								[avatarAdditionalAttributes]="avatarAdditionalAttributes" />
							<div class="min-w-0">
								<div class="fw-semibold text-truncate">{{ admin.firstName }} {{ admin.lastName }}</div>
								@if (admin.emailAddress) {
									<div class="text-muted small text-truncate">{{ admin.emailAddress }}</div>
								}
							</div>
						</div>
						<a [routerLink]="['/members/profile', admin.memberId]" class="btn btn-sm btn-ms-secondary text-nowrap ms-2">
							View Profile
						</a>
					</div>
				}
			</div>
		}
	</div>
</div>
